import { render, staticRenderFns } from "./TeamWorkshiftPlan.vue?vue&type=template&id=08cfa38d"
import script from "./TeamWorkshiftPlan.vue?vue&type=script&lang=js"
export * from "./TeamWorkshiftPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports